import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { BrandLogo } from "@/components/BrandLogo";
import { Button } from "@/components/ui/button";
import { LogOut, User } from "lucide-react";

export default function AuditShell() {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    const handleLogout = () => { logout(); nav("/login"); };

    return (
        <div className="min-h-screen bg-background flex flex-col">
            <header className="sticky top-0 z-30 bg-[hsl(var(--trulyn-navy))] text-white">
                <div className="px-4 py-3 flex items-center justify-between gap-2">
                    <NavLink to="/audit" data-testid="audit-home-link">
                        <BrandLogo size={42} light withSubtitle={false} />
                    </NavLink>
                    <div className="flex items-center gap-2">
                        <span className="text-[11px] px-2 py-0.5 rounded-full bg-emerald-500/20 text-emerald-100 border border-emerald-400/40 font-semibold">
                            Auditor
                        </span>
                        <Button
                            variant="ghost"
                            size="icon"
                            className="text-white hover:bg-white/10"
                            onClick={handleLogout}
                            data-testid="audit-logout-button"
                            title="Salir"
                        >
                            <LogOut className="w-5 h-5" />
                        </Button>
                    </div>
                </div>
                <div className="px-4 pb-2 text-xs text-white/70 truncate flex items-center gap-1">
                    <User className="w-3 h-3" /> {user?.full_name}
                </div>
            </header>

            <main className="flex-1 max-w-2xl w-full mx-auto pb-24">
                <Outlet />
            </main>
        </div>
    );
}
